<app-page-header [title]="'Countries'" [subtitle]="'Manage countries for SampleStudio'"></app-page-header>
<div class="mb-6">
    <div class="flex justify-between mb-2">
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-search"></p-inputicon>
                <input pInputText id="country_search" [(ngModel)]="this.search" (input)="onSearchInputChange()"
                       autocomplete="off"/>
            </p-iconfield>
            <label for="country_search">Search country</label>
        </p-ifta-label>
        <p-button label="Add Country" icon="pi pi-plus" (click)="this.openCreateCountryDialog()" isAdmin
                  [hidden]="false"></p-button>
    </div>
    <div class="border border-gray-300 dark:border-gray-700 p-2 dark:p-0 mb-5 rounded-sm">
        <p-table
                [value]="this.countries"
                [paginator]="true"
                [rows]="this.rows"
                [totalRecords]="this.totalRecords"
                [lazy]="true"
                [first]="this.currentPage * this.rows"
                [loading]="this.loading"
                [rowsPerPageOptions]="[5, 10, 20]"
                (onLazyLoad)="this.onPageChange($event)"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>Name</th>
                    <th>DEP Market Name</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-country>
                <tr>
                    <td>{{ country.name }}</td>
                    <td>{{ country.depMarketName ?? ''}}</td>
                    <td>
                        <div class="flex justify-end">
                            <p-button icon="pi pi-eye" text
                                      pTooltip="View country"
                                      tooltipPosition="left"
                                      routerLink="/countries/country/{{country.id}}"></p-button>

                            <p-button icon="pi pi-pencil" text
                                      isAdmin
                                      pTooltip="Edit country"
                                      tooltipPosition="left"
                                      (click)="this.editCountry(country)"></p-button>

                            <p-button icon="pi pi-trash" text
                                      isAdmin
                                      pTooltip="Delete country"
                                      tooltipPosition="left"
                                      (click)="this.deleteCountry(country)"
                                      severity="danger"></p-button>
                        </div>

                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
<div class="flex gap-2 mb-6">
    <p-button label="Export all Countries" icon="pi pi-download" (click)="this.exportCountries()"
              severity="secondary"></p-button>
</div>

<!-- Create Country Dialog -->
<app-create-country-dialog
        [(visible)]="this.displayCreateCountryDialog"
        (countryCreated)="this.reloadCountries()"
></app-create-country-dialog>

<!-- Update Country Dialog -->
<app-update-country-dialog
        [(visible)]="this.displayUpdateCountryDialog"
        [country]="this.selectedCountry"
        (countryUpdated)="this.reloadCountries()"
></app-update-country-dialog>
